import React from 'react'
import '../TermsConditions/TermsConditions.css';
import Navbar from '../../Componect/Navbar/Navbar'
import FooterBottom from '../../Componect/Footer/FooterBottom'

function TermsConditions() {
return (
    <>
    <div className='TermsConditions'>
            <Navbar></Navbar>
            <div className='TermsConditionsTxt'>
                    <h1>Terms & Conditions</h1>
                    <p>By using স তে সতেরো services, you agree to the following terms:</p>
                    <ul>
                            <li>
                                    <strong>Use of Services:</strong> Our website and services are for personal use only. Providing false information or misuse is prohibited.
                            </li>
                            <li>
                                    <strong>Orders & Payments:</strong> Orders are subject to availability. Prices may change without notice. Payments must be made through approved methods.
                            </li>
                            <li>
                                    <strong>Cancellations & Refunds:</strong> Orders can be canceled before preparation starts. Refunds (if applicable) will follow our policy.
                            </li>
                            <li>
                                    <strong>Privacy & Cookies:</strong> We collect and use data as per our Privacy Policy and Cookie Policy.
                            </li>
                            <li>
                                    <strong>Liability:</strong> We are not responsible for external issues affecting service. Our liability is limited to the order value.
                            </li>
                            <li>
                                    <strong>Contact Us:</strong>
                                    <ul>
                                            <li>📧 Email: stesotero53@gmail.com</li>
                                            <li>📞 Phone: 01780-126370</li>
                                            <li>📍 Address: Sector-17, Block-I, Road-10, Plot-26, Uttara, Dhaka</li>
                                    </ul>
                            </li>
                    </ul>
                    <p>By using our services, you accept these terms.</p>
            </div>
            <FooterBottom></FooterBottom>
    </div>
    </>
)
}

export default TermsConditions